import { colors } from '@kmns-internal/furikake'
import { Box, Stack, Typography } from '@mui/material'
import type React from 'react'
import { isLegacyCompany } from 'src/features/legacyFeatures/isLegacyCompany'
import IndustryCardGrid from 'src/features/templateEdit/common/IndustryCardGrid'
import type { IndustryInfo } from 'src/features/templateEdit/onboardingDynamic/types'

interface OwnProps {
  showNewTemplates?: IndustryInfo[][]
  onClick: (industry: IndustryInfo) => void
}

const ShowNewTemplateType: React.FC<OwnProps> = (props: OwnProps) => {
  const templates = props.showNewTemplates ?? []
  // @legacy-feature: 表形式、スクロール2列、紙芝居廃止
  const isLegacy = isLegacyCompany()
  // アイテム数に応じてカラム数を制御する（1つなら1列、2つ以上なら2列）
  // IndustryCardGrid が T[][] を受ける設計だが、グループは常に1つしかないため [0] で参照する
  const itemCount = templates[0]?.length ?? 0
  const smColumns = itemCount <= 1 ? 1 : 2

  return (
    <>
      {isLegacy ? (
        <Typography
          variant="subtitle1"
          fontWeight="bold"
          textAlign="center"
          mt={8}
          mb={2}
        >
          空のひな形からつくる
        </Typography>
      ) : (
        <Box mt={8} />
      )}
      <IndustryCardGrid
        showIndustries={templates}
        onClick={props.onClick}
        smColumns={smColumns}
        buttonJustifyContent="space-between"
        renderCardContent={industry => (
          <>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="flex-start"
              spacing={2}
            >
              {industry.svgComponent && (
                <industry.svgComponent
                  width={48}
                  height={48}
                  style={{
                    width: 48,
                    height: 48,
                    color: colors.primary.main,
                  }}
                />
              )}
              <Stack direction="column" spacing={0.5} alignItems="flex-start">
                <Typography variant="body1" fontWeight="bold" textAlign="left">
                  {industry.title}
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  textAlign="left"
                >
                  {industry.description}
                </Typography>
              </Stack>
            </Stack>
            {industry.svgDescriptionComponent && (
              <Stack direction="row" alignItems="center" spacing={1}>
                {industry.svgDescriptionComponent.map(
                  (
                    Item: React.FunctionComponent<
                      React.SVGProps<SVGSVGElement>
                    >,
                  ) => (
                    <Stack
                      key={Item.displayName ?? Item.name}
                      direction="row"
                      alignItems="center"
                      spacing={0.5}
                    >
                      <Item width={48} height={48} />
                    </Stack>
                  ),
                )}
              </Stack>
            )}
          </>
        )}
      />
    </>
  )
}

export default ShowNewTemplateType
